/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_SubmitInputs */

const vi_einvoice_submit = /** @type {(inputs: Einvoice_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất HĐĐT`)
};

/**

* @param {Einvoice_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_submit = /** @type {((inputs?: Einvoice_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_submit(inputs)
});